export const PROGRESS_STEP_TWO = 'PROGRESS_STEP_TWO'
export const REGRESS_STEP_TWO = 'REGRESS_STEP_TWO'

export const GET_RECOMMENDED_PROGRAMS_REQUEST = 'GET_RECOMMENDED_PROGRAMS_REQUEST'
export const GET_RECOMMENDED_PROGRAMS_SUCCESS = 'GET_RECOMMENDED_PROGRAMS_SUCCESS'
export const GET_RECOMMENDED_PROGRAMS_FAIL = 'GET_RECOMMENDED_PROGRAMS_FAIL'
